import { Badge } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { Userpilot } from "userpilot";
import { EnergyRevenuesCellCheckStateState } from "../../../../../types/api.types";
import type { EnergyRevenuesCellCheckStateResponse } from "../../../RevenueMonitoring.types";

export const VERIFICATION_OPTIONS = [
  {
    label: "In Prüfung",
    value: EnergyRevenuesCellCheckStateState.inProgress,
    color: "blue"
  },
  {
    label: "Einspruch",
    value: EnergyRevenuesCellCheckStateState.objection,
    color: "error"
  },
  {
    label: "Geprüft",
    value: EnergyRevenuesCellCheckStateState.verified,
    color: "success"
  }
];

export function getStatusColumn(): MRT_ColumnDef<EnergyRevenuesCellCheckStateResponse> {
  return {
    header: "Status",
    accessorKey: "state",
    Cell: ({ cell }) => {
      const stateDetails = VERIFICATION_OPTIONS.find(
        (option) =>
          option.value ===
          cell.getValue<EnergyRevenuesCellCheckStateResponse["state"]>()
      );
      return stateDetails ? (
        <Badge color={stateDetails.color} w={100}>
          {stateDetails.label}
        </Badge>
      ) : null;
    },
    editVariant: "select",
    mantineEditSelectProps: {
      "aria-label": "Status",
      className: `verification-state-edit-dropdown`,
      data: VERIFICATION_OPTIONS,
      onClick: () => Userpilot.track("em_prufansicht_status_feld")
    },
    filterVariant: "multi-select",
    enableColumnFilterModes: false,
    mantineFilterMultiSelectProps: {
      data: VERIFICATION_OPTIONS
    },
    size: 140
  };
}
